const FontManager = class {
    constructor() {
        this.fonts = {};
    }

    add(name, source) {
        if(!name || !source || this.fonts.hasOwnProperty(name)) {
            return;
        }
        const font = new FontFace(name, source);
        document.fonts.add(font);
        this.fonts[name] = font;
    }

    remove(name) {
        if(name && this.fonts.hasOwnProperty(name)) {
            document.fonts.delete(this.fonts[name]);
            delete this.fonts[name];
        }
    }

    clear() {
        document.fonts.clear();
        this.fonts = {};
    }
}

export default new FontManager();
